// extracted by mini-css-extract-plugin
export default {"link":"ProfileLink_link__vh-h8","text":"ProfileLink_text__jcI+J","icon":"ProfileLink_icon__6XIsB"};